/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { APP_BASE_HREF } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LOCALE_ID, NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CoreModule } from './@core/core.module';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ThemeModule } from './@theme/theme.module';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationGuardService } from './services/authentication/authentication-guard.service';
import { AuthenticationService } from './services/authentication/authentication.service';
import { TokenService } from './services/token/token.service';
import { StorageService } from './services/storage/storage.service';
import { ConfigService } from './services/config/config.service';
import { ApiService } from './services/api/api.service';
import { UserService } from './services/user/user.service';
import { ApiInterceptor } from './services/api/api.interceptor';
import { LocationsService } from './services/locations/locations.service';
import { GlobalModule } from './components/global.module';
import { GroupsService } from './services/groups/groups.service';
import { ShardHandlerService } from './services/sharding/shard-handler.service';
import { registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';
import { NgbDateNLParserFormatter } from './ngb-date-nl-parser-formatter';
import { ToasterModule } from 'angular2-toaster';
import {NbChatModule, NbDatepickerModule} from '@nebular/theme';
import { RootRedirectorComponent } from './root-redirector/root-redirector.component';
import * as moment from 'moment';
import {BreadModule} from './bread/bread.module';
import {PagesModule} from './pages/pages.module';
import {CloudinaryModule} from '@cloudinary/angular-5.x'
import CloudinaryConfiguration from '@cloudinary/angular-5.x/src/cloudinary-configuration.class'
import {Cloudinary} from 'cloudinary-core'

registerLocaleData(localeNl, 'nl');
moment.locale('nl');

@NgModule({
  declarations: [
    AppComponent,
    RootRedirectorComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NgbModule.forRoot(),
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
    ToasterModule.forRoot(),
    NbChatModule.forRoot(),
    NbDatepickerModule.forRoot(),
    GlobalModule,
    CloudinaryModule.forRoot({Cloudinary}, {cloud_name: 'wedaycare'} as CloudinaryConfiguration),
  ],
  bootstrap: [AppComponent],
  providers: [
    {provide: APP_BASE_HREF, useValue: '/'},
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true,
    },
    {provide: LOCALE_ID, useValue: 'nl'},
    {provide: NgbDateParserFormatter, useClass: NgbDateNLParserFormatter},
    AuthenticationGuardService,
    AuthenticationService,
    TokenService,
    StorageService,
    ConfigService,
    UserService,
    LocationsService,
    GroupsService,
    ShardHandlerService,
    ApiService,
  ],
})
export class AppModule {
}
